import React, { useState } from 'react';
import './AddWhiskyForm.css'; // Reuse the same styles

const EditWhiskyForm = ({ whisky, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    name: whisky.name || '',
    distillery: whisky.distillery || '',
    region: whisky.region || '',
    age: whisky.age || '',
    abv: whisky.abv || '',
    type: whisky.type || 'Single Malt'
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!formData.name.trim()) {
      alert('Please enter a whisky name');
      return;
    }

    const updatedWhisky = {
      ...whisky, // Keep the original ID and any other properties
      name: formData.name.trim(),
      distillery: formData.distillery.trim(),
      region: formData.region.trim(),
      age: formData.age.trim(),
      abv: formData.abv.trim(),
      type: formData.type
    };

    onSubmit(updatedWhisky);
  };

  return (
    <div className="add-whisky-form">
      <div className="form-header">
        <h2>Edit Whisky</h2>
        <button className="close-btn" onClick={onCancel}>✕</button>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="form-section">
          <h3>Whisky Details</h3>
          
          <div className="form-group">
            <label htmlFor="name">Name *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="e.g., Lagavulin 16"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="distillery">Distillery</label>
            <input
              type="text"
              id="distillery"
              name="distillery"
              value={formData.distillery}
              onChange={handleInputChange}
              placeholder="e.g., Lagavulin"
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="region">Region</label>
              <select
                id="region"
                name="region"
                value={formData.region}
                onChange={handleInputChange}
              >
                <option value="">Select Region</option>
                <option value="Highlands">Highlands</option>
                <option value="Lowlands">Lowlands</option>
                <option value="Speyside">Speyside</option>
                <option value="Islay">Islay</option>
                <option value="Campbeltown">Campbeltown</option>
                <option value="Islands">Islands</option>
                <option value="Ireland">Ireland</option>
                <option value="America">America</option>
                <option value="Japan">Japan</option>
                <option value="Other">Other</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="type">Type</label>
              <select
                id="type"
                name="type"
                value={formData.type}
                onChange={handleInputChange}
              >
                <option value="Single Malt">Single Malt</option>
                <option value="Blended">Blended</option>
                <option value="Grain">Grain</option>
                <option value="Bourbon">Bourbon</option>
                <option value="Rye">Rye</option>
                <option value="Irish">Irish</option>
                <option value="Japanese">Japanese</option>
                <option value="Other">Other</option>
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="age">Age</label>
              <input
                type="text"
                id="age"
                name="age"
                value={formData.age}
                onChange={handleInputChange}
                placeholder="e.g., 16 years, NAS"
              />
            </div>

            <div className="form-group">
              <label htmlFor="abv">ABV (%)</label>
              <input
                type="text"
                id="abv"
                name="abv"
                value={formData.abv}
                onChange={handleInputChange}
                placeholder="e.g., 43"
              />
            </div>
          </div>
        </div>

        <div className="form-actions">
          <button type="button" className="btn btn-secondary" onClick={onCancel}>
            Cancel
          </button>
          <button type="submit" className="btn btn-primary">
            Save Changes
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditWhiskyForm;
